import React, { FC, useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import laverie from "../assets/images/laverie1.jpg";
import laverie2 from "../assets/images/consolelaverie.jpeg";

import letscleanjerba1 from "../assets/NosStations/letscleanjerba1.jpeg"
import letscleanjerba3 from "../assets/NosStations/letscleanjerba3.jpeg"


type LaverieCardProps = {
  images: string[];
  selectedIndex: number;
  onChange: (index: number) => void;
  title: string;
  description: string;
  mapHref: string;
  linkLabel: string;
};

const LaverieCard: FC<LaverieCardProps> = ({
  images,
  selectedIndex,
  onChange,
  title,
  description,
  mapHref,
  linkLabel,
}) => (
<div className="group flex w-full sm:max-w-sm md:max-w-md flex-col overflow-hidden rounded-2xl bg-white border border-gray-100 shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
<div className="relative h-52 sm:h-60 md:h-64 w-full overflow-hidden bg-gray-100">
        <Carousel
        selectedItem={selectedIndex}
        onChange={onChange}
        showThumbs={false}
        showStatus={false}
        showArrows={false}
        showIndicators={false}
        swipeable={false}
        emulateTouch={false}
        autoPlay={true}
        infiniteLoop
        interval={3000}
        className="h-52 sm:h-60 md:h-64"
      >
        {images.map((image, index) => (
<div
  key={index}
  className="h-52 sm:h-60 md:h-64 relative flex items-center justify-center bg-gray-200"
>
              <img src={image} className="absolute inset-0 w-full h-full object-contain bg-white" />
          </div>
        ))}
      </Carousel>
      <div className="absolute inset-0 bg-gradient-to-t from-blue-900/30 via-transparent to-transparent pointer-events-none"></div>
    </div>

    <div className="flex flex-1 flex-col p-6">
      <div className="mb-3 h-1 w-10 rounded-full bg-yellow-400 group-hover:w-16 transition-all duration-300"></div>
      <h3 className="text-lg font-bold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600 text-sm leading-relaxed flex-1">{description}</p>

      <a
        href={mapHref}
        target="_blank"
        rel="noopener noreferrer"
className="mt-5 inline-flex items-center justify-center gap-2 rounded-full bg-blue-600 px-4 sm:px-5 py-2.5 text-[11px] sm:text-xs font-bold uppercase tracking-wide text-white shadow-md transition-all duration-300 hover:bg-blue-700 hover:shadow-blue-500/40"      >
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 21C12 21 19 15.5 19 10.5C19 6.4 15.6 3 12 3C8.4 3 5 6.4 5 10.5C5 15.5 12 21 12 21Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
          <circle cx="12" cy="10.5" r="2.5" stroke="currentColor" strokeWidth="2" />
        </svg>
        {linkLabel}
      </a>
    </div>
  </div>
);


const CleanPressing: FC = () => {
  const [currentSokraImage, setCurrentSokraImage] = useState(0);
  const [currentDjerbaImage, setCurrentDjerbaImage] = useState(0);

  const imagessokra = [laverie, laverie2];

  const imagesletscleanjerba = [letscleanjerba1, letscleanjerba3];
const laveries = [
  {
    images: imagessokra,
    title: "DROP & DRY",
    description: "Laverie self-service moderne située à Sokra Sfax.",
    mapHref: "https://maps.app.goo.gl/2kqKZzGZ1onRGBqM7?g_st=aw",
    selectedIndex: currentSokraImage,
    setIndex: setCurrentSokraImage,
  },
  {
    images: imagesletscleanjerba,
    title: "Let's Clean Djerba",
    description: "Découvrez notre station Let's Clean Djerba",
    mapHref: "https://maps.app.goo.gl/SauEscbY22wS1eLy8?g_st=iw",
    selectedIndex: currentDjerbaImage,
    setIndex: setCurrentDjerbaImage,
  },
];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSokraImage((prev) =>
        prev === imagessokra.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDjerbaImage((prev) =>
        prev === imagesletscleanjerba.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">

      {/* HERO */}
<div className="relative bg-gradient-to-br from-blue-700 via-blue-700 to-blue-900 pt-28 sm:pt-32 md:pt-36 pb-16 sm:pb-24 md:pb-28 px-4 sm:px-6 text-center overflow-hidden">
<div className="relative z-10 max-w-3xl mx-auto mt-6">          <span className="inline-flex items-center gap-2 text-yellow-400 text-xs font-bold tracking-[0.25em] uppercase mb-4">
            <span className="w-8 h-px bg-yellow-400"></span>
            Clean Pressing
            <span className="w-8 h-px bg-yellow-400"></span>
          </span>

<h1 className="text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-black text-white mb-6">            Laverie self-service
          </h1>

<p className="text-blue-100/90 text-sm sm:text-base md:text-lg leading-relaxed px-2">
            Découvrez nos stations de laverie self-service modernes, conçues pour vous offrir une expérience rapide, autonome et de haute qualité.
          </p>
        </div>
      </div>

      <div className="px-6 pb-16">

  <section className="pt-16">

    {/* HEADER GLOBAL */}
    <div className="flex flex-col items-center mb-10">
      <span className="text-yellow-500 text-xs font-bold tracking-[0.2em] uppercase mb-2">
        Nos laveries
      </span>
      <div className="mt-4 h-1.5 w-16 rounded-full bg-gradient-to-r from-blue-600 to-yellow-400"></div>
    </div>

    {/* LISTE UNIQUE */}
<div className="grid grid-cols-1 md:grid-cols-2 gap-8 justify-items-center">
        {laveries.map((item) => (
        <LaverieCard
          key={item.title}
          images={item.images}
          selectedIndex={item.selectedIndex}
          onChange={item.setIndex}
          title={item.title}
          description={item.description}
          mapHref={item.mapHref}
          linkLabel="Localisation"
        />
      ))}
    </div>

  </section>

</div>

      </div>
  );
};

export default CleanPressing;